import React, { ReactElement } from "react";
import classNames from "classnames";
import moment from "moment";
import { ArrowDownIcon } from "@kursk/components/ui/icons";
import styles from "./DatePickerHeader.module.scss";

export const DatePickerHeader = ({ decreaseMonth, increaseMonth, customHeaderCount, monthDate }): ReactElement => {
  return (
    <div className={styles.headerContainer}>
      <div
        style={customHeaderCount === 1 ? { visibility: "hidden" } : null}
        className={classNames(styles.arrowIcon, styles.iconLeft)}
        onClick={decreaseMonth}>
        <ArrowDownIcon width={16} height={6} />
      </div>
      <div className={styles.dateInfo}>
        <div className={styles.textMonth}>{moment(monthDate).format('MMMM YYYY')}</div>
      </div>
      <div
        style={customHeaderCount === 0 ? { visibility: "hidden" } : null}
        className={classNames(styles.arrowIcon, styles.iconRight)}
        onClick={increaseMonth}>
        <ArrowDownIcon width={16} height={6} />
      </div>
    </div>
  )
}
